module.exports = __webpack_public_path__ + "img/img-infj.d1eadb01.jpg";